import React, { useEffect, useState } from 'react'
import {
    Container, Grid2, Card, CardContent, Typography, Box, Avatar,
    LinearProgress, Chip, IconButton, Paper, Fade, Grow,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Badge
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ModernNavbar from './ModernNavbar'
import Footer from './Footer'
import { getCompanyData } from '../../features/setup/useableSlice'
import { getEmployeeList } from '../../features/PayrollManagement/employeeSlice'
import { getDepartments } from '../../features/AdminManagement/departmentSlice'
import { getUnits } from '../../features/AdminManagement/unitsSlice'
import { getDesignations } from '../../features/AdminManagement/designationsSlice'
import { getShifts } from '../../features/AdminManagement/shiftsSlice'
import { getAllowances } from '../../features/AdminManagement/allowancesSlice'
import { getLeaves } from '../../features/AdminManagement/leaveSlice'

// Icons
import PeopleIcon from '@mui/icons-material/People'
import BusinessIcon from '@mui/icons-material/Business'
import WorkIcon from '@mui/icons-material/Work'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import AssignmentIcon from '@mui/icons-material/Assignment'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import GroupsIcon from '@mui/icons-material/Groups'
import BeachAccessIcon from '@mui/icons-material/BeachAccess'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import StarIcon from '@mui/icons-material/Star'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'

// Animated Stats Card Component
function StatsCard({ title, value, icon, color, gradient, route, trend, percentage }) {
    const navigate = useNavigate()
    const [hover, setHover] = useState(false)

    return (
        <Grow in timeout={500}>
            <Card
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => navigate(route)}
                sx={{
                    cursor: 'pointer',
                    height: '100%',
                    background: hover ? gradient : `linear-gradient(135deg, ${color}15 0%, ${color}30 100%)`,
                    backdropFilter: 'blur(10px)',
                    border: `2px solid ${hover ? color : 'transparent'}`,
                    borderRadius: 4,
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    transform: hover ? 'translateY(-8px) scale(1.02)' : 'translateY(0) scale(1)',
                    boxShadow: hover
                        ? `0 20px 40px ${color}40, 0 0 20px ${color}20`
                        : '0 4px 12px rgba(0,0,0,0.08)',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '4px',
                        background: gradient,
                        transform: hover ? 'scaleX(1)' : 'scaleX(0)',
                        transition: 'transform 0.3s ease',
                    }
                }}
            >
                <CardContent sx={{ position: 'relative', zIndex: 1 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                        <Box>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#555',
                                    fontWeight: 700,
                                    fontSize: '0.875rem',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                }}
                            >
                                {title}
                            </Typography>
                            <Typography
                                variant="h3"
                                sx={{
                                    fontWeight: 900,
                                    color: '#4da6ffff',
                                    mt: 1,
                                    fontSize: { xs: '2.5rem', md: '3rem' },
                                    textShadow: `0 2px 8px ${color}30`
                                }}
                            >
                                {value || 0}
                            </Typography>
                        </Box>
                        <Avatar
                            sx={{
                                bgcolor: '#1E90FF',
                                color: 'white',
                                width: 60,
                                height: 60,
                                transition: 'all 0.3s ease',
                                transform: hover ? 'rotate(360deg) scale(1.15)' : 'rotate(0deg) scale(1)',
                                boxShadow: `0 4px 12px ${color}50`
                            }}
                        >
                            {icon}
                        </Avatar>
                    </Box>

                    {/* {percentage && (
                        <Box mt={2}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                                <Typography variant="caption" sx={{ color: '#666', fontWeight: 600 }}>
                                    Growth Rate
                                </Typography>
                                <Chip
                                    icon={<TrendingUpIcon sx={{ fontSize: 14, color: 'white' }} />}
                                    label={`${percentage}%`}
                                    size="small"
                                    sx={{
                                        bgcolor: trend === 'up' ? '#4caf50' : '#f44336',
                                        color: 'white',
                                        fontWeight: 700,
                                        fontSize: '0.75rem',
                                    }}
                                />
                            </Box>
                            <LinearProgress
                                variant="determinate"
                                value={percentage}
                                sx={{
                                    height: 8,
                                    borderRadius: 4,
                                    bgcolor: `${color}20`,
                                    '& .MuiLinearProgress-bar': {
                                        bgcolor: color,
                                        borderRadius: 4,
                                        boxShadow: `0 2px 6px ${color}40`
                                    }
                                }}
                            />
                        </Box>
                    )} */}
                </CardContent>

                {/* Decorative circles */}
                <Box
                    sx={{
                        position: 'absolute',
                        right: -30,
                        bottom: -30,
                        width: 120,
                        height: 120,
                        borderRadius: '50%',
                        background: `${color}10`,
                        transition: 'all 0.3s ease',
                        transform: hover ? 'scale(1.2)' : 'scale(1)',
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        right: -50,
                        bottom: -50,
                        width: 150,
                        height: 150,
                        borderRadius: '50%',
                        background: `${color}05`,
                        transition: 'all 0.3s ease',
                        transform: hover ? 'scale(1.3)' : 'scale(1)',
                    }}
                />
            </Card>
        </Grow>
    )
}

// Quick Action Card
function QuickActionCard({ title, description, icon, color, route }) {
    const navigate = useNavigate()
    const [hover, setHover] = useState(false)

    return (
        <Paper
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={() => navigate(route)}
            elevation={hover ? 8 : 2}
            sx={{
                p: 2.5,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                transform: hover ? 'translateX(8px)' : 'translateX(0)',
                borderLeft: `4px solid ${color}`,
                '&:hover': {
                    bgcolor: `${color}08`,
                }
            }}
        >
            <Box display="flex" alignItems="center" gap={2}>
                <Avatar sx={{ bgcolor: `${color}20`, color: color }}>
                    {icon}
                </Avatar>
                <Box flex={1}>
                    <Typography variant="subtitle1" fontWeight={700} color="text.primary">
                        {title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {description}
                    </Typography>
                </Box>
                <IconButton
                    size="small"
                    sx={{
                        bgcolor: `${color}15`,
                        color: color,
                        transition: 'all 0.3s ease',
                        transform: hover ? 'translateX(4px)' : 'translateX(0)',
                    }}
                >
                    →
                </IconButton>
            </Box>
        </Paper>
    )
}

// Department Chart Card
function DepartmentChartCard({ departments, employees }) {
    // Fixed colors array for consistency - Based on #1E90FF theme
    const colorPalette = ['#1E90FF', '#4facfe', '#00bfff', '#5fa3ff', '#87ceeb', '#1c86ee', '#1874cd', '#187bcd']

    const deptStats = departments.map((dept, index) => {
        // Filter employees by department name - backend sends 'deptName' field in employees
        const deptName = dept.deptName
        const deptEmps = employees.filter(emp =>
            emp.deptName === deptName
        )

        // console.log(`Department: ${deptName}, Employee Count: ${deptEmps.length}`)

        return {
            name: deptName || 'Unknown',
            count: deptEmps.length,
            color: colorPalette[index % colorPalette.length] // Fixed color based on index
        }
    })
        .filter(dept => dept.count > 0) // Only show departments with employees
        .sort((a, b) => b.count - a.count)
        .slice(0, 6) // Show top 6 departments

    const maxCount = Math.max(...deptStats.map(d => d.count), 1)

    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
                backdropFilter: 'blur(20px)',
                borderRadius: 4,
                border: '1px solid rgba(255,255,255,0.3)',
                height: '100%',
            }}
        >
            <Typography
                variant="h6"
                fontWeight={800}
                mb={3}
                sx={{
                    background: 'linear-gradient(135deg, #1E90FF 0%, #1c86ee 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}
            >
                📊 Employees by Department
            </Typography>
            <Box>
                {deptStats.length === 0 ? (
                    <Box textAlign="center" py={4}>
                        <Typography variant="body2" color="text.secondary">
                            No departments with employees found
                        </Typography>
                    </Box>
                ) : (
                    deptStats.map((dept, index) => (
                        <Fade in timeout={500 + index * 100} key={index}>
                            <Box mb={2.5}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                    <Box display="flex" alignItems="center" gap={1.5} flex={1}>
                                        <Box
                                            sx={{
                                                width: 16,
                                                height: 16,
                                                borderRadius: '50%',
                                                bgcolor: dept.color,
                                                boxShadow: `0 0 8px ${dept.color}60`,
                                            }}
                                        />
                                        <Typography
                                            variant="body2"
                                            fontWeight={600}
                                            sx={{
                                                color: 'text.primary',
                                                fontSize: '0.95rem'
                                            }}
                                        >
                                            {dept.name}
                                        </Typography>
                                    </Box>
                                    <Chip
                                        label={`${dept.count} Emp${dept.count !== 1 ? 's' : ''}`}
                                        size="small"
                                        sx={{
                                            bgcolor: `${dept.color}20`,
                                            color: dept.color,
                                            fontWeight: 700,
                                            fontSize: '0.8rem',
                                            minWidth: '70px',
                                        }}
                                    />
                                </Box>
                                <LinearProgress
                                    variant="determinate"
                                    value={(dept.count / maxCount) * 100}
                                    sx={{
                                        height: 10,
                                        borderRadius: 5,
                                        bgcolor: `${dept.color}15`,
                                        '& .MuiLinearProgress-bar': {
                                            bgcolor: dept.color,
                                            borderRadius: 5,
                                            boxShadow: `0 2px 8px ${dept.color}40`,
                                        }
                                    }}
                                />
                            </Box>
                        </Fade>
                    ))
                )}
            </Box>
        </Paper>
    )
}

// Top Performers Card
function TopPerformersCard({ employees }) {
    // Calculate performance score based on employee data
    const topPerformers = employees
        .map(emp => ({
            ...emp,
            score: Math.floor(Math.random() * 30) + 70, // Random score between 70-100 for demo
        }))
        .sort((a, b) => b.score - a.score)
        .slice(0, 5)

    const getScoreColor = (score) => {
        if (score >= 90) return '#43e97b'
        if (score >= 80) return '#4facfe'
        if (score >= 70) return '#fa709a'
        return '#f093fb'
    }

    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
                backdropFilter: 'blur(20px)',
                borderRadius: 4,
                border: '1px solid rgba(255,255,255,0.3)',
                height: '100%',
            }}
        >
            <Typography
                variant="h6"
                fontWeight={800}
                mb={3}
                sx={{
                    background: 'linear-gradient(135deg, #1E90FF 0%, #1c86ee 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}
            >
                🏆 Top Performers
            </Typography>
            <Box>
                {topPerformers.map((emp, index) => (
                    <Fade in timeout={500 + index * 100} key={index}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2,
                                p: 2,
                                mb: 1.5,
                                borderRadius: 3,
                                bgcolor: index === 0 ? '#ffd70015' : 'transparent',
                                border: index === 0 ? '2px solid #ffd700' : '1px solid #f0f0f0',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateX(8px)',
                                    bgcolor: '#f8f9fa',
                                }
                            }}
                        >
                            <Badge
                                badgeContent={index === 0 ? <EmojiEventsIcon sx={{ fontSize: 16, color: '#ffd700' }} /> : null}
                                overlap="circular"
                            >
                                <Avatar
                                    sx={{
                                        bgcolor: getScoreColor(emp.score),
                                        fontWeight: 700,
                                    }}
                                >
                                    {emp.employeeName?.charAt(0) || 'E'}
                                </Avatar>
                            </Badge>
                            <Box flex={1}>
                                <Typography variant="body2" fontWeight={700}>
                                    {emp.employeeName || 'Employee'}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {emp.designation || 'Staff'}
                                </Typography>
                            </Box>
                            <Box textAlign="right">
                                <Typography
                                    variant="h6"
                                    fontWeight={800}
                                    sx={{ color: getScoreColor(emp.score) }}
                                >
                                    {emp.score}
                                </Typography>
                                <Box display="flex" alignItems="center" gap={0.5}>
                                    {[...Array(5)].map((_, i) => (
                                        <StarIcon
                                            key={i}
                                            sx={{
                                                fontSize: 12,
                                                color: i < Math.floor(emp.score / 20) ? '#ffd700' : '#ddd',
                                            }}
                                        />
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    </Fade>
                ))}
            </Box>
        </Paper>
    )
}

// Attendance Overview Card
function AttendanceOverviewCard({ employees }) {
    const totalEmployees = employees.length
    const presentToday = Math.floor(totalEmployees * 0.85) // 85% present for demo
    const absentToday = Math.floor(totalEmployees * 0.10) // 10% absent
    const lateToday = totalEmployees - presentToday - absentToday // Rest are late

    const attendanceData = [
        { label: 'Present', value: presentToday, color: '#43e97b', icon: <CheckCircleIcon /> },
        { label: 'Absent', value: absentToday, color: '#f093fb', icon: <CancelIcon /> },
        { label: 'Late', value: lateToday, color: '#fa709a', icon: <AccessTimeIcon /> },
    ]

    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
                backdropFilter: 'blur(20px)',
                borderRadius: 4,
                border: '1px solid rgba(255,255,255,0.3)',
                height: '100%',
            }}
        >
            <Typography
                variant="h6"
                fontWeight={800}
                mb={3}
                sx={{
                    background: 'linear-gradient(135deg, #1E90FF 0%, #1c86ee 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}
            >
                📅 Today's Attendance
            </Typography>

            {/* Circular Progress Display */}
            <Box display="flex" justifyContent="center" mb={3}>
                <Box position="relative" display="inline-flex">
                    <Box
                        sx={{
                            width: 150,
                            height: 150,
                            borderRadius: '50%',
                            background: `conic-gradient(
                                #43e97b 0% ${(presentToday / totalEmployees) * 100}%,
                                #fa709a ${(presentToday / totalEmployees) * 100}% ${((presentToday + lateToday) / totalEmployees) * 100}%,
                                #f093fb ${((presentToday + lateToday) / totalEmployees) * 100}% 100%
                            )`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Box
                            sx={{
                                width: 110,
                                height: 110,
                                borderRadius: '50%',
                                bgcolor: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography variant="h3" fontWeight={900} color="#1E90FF">
                                {Math.round((presentToday / totalEmployees) * 100)}%
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                Present
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* Stats Breakdown */}
            <Box>
                {attendanceData.map((item, index) => (
                    <Fade in timeout={500 + index * 100} key={index}>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            p={1.5}
                            mb={1}
                            sx={{
                                borderRadius: 2,
                                bgcolor: `${item.color}10`,
                                border: `1px solid ${item.color}30`,
                            }}
                        >
                            <Box display="flex" alignItems="center" gap={1.5}>
                                <Avatar sx={{ bgcolor: item.color, width: 32, height: 32 }}>
                                    {React.cloneElement(item.icon, { sx: { fontSize: 18 } })}
                                </Avatar>
                                <Typography variant="body2" fontWeight={600}>
                                    {item.label}
                                </Typography>
                            </Box>
                            <Typography variant="h6" fontWeight={800} color={item.color}>
                                {item.value}
                            </Typography>
                        </Box>
                    </Fade>
                ))}
            </Box>
        </Paper>
    )
}

// Recent Employees Card
function RecentEmployeesCard({ employees }) {
    const recentEmployees = [...employees]
        .sort((a, b) => (b.empID || 0) - (a.empID || 0))
        .slice(0, 5)

    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
                backdropFilter: 'blur(20px)',
                borderRadius: 4,
                border: '1px solid rgba(255,255,255,0.3)',
                height: '100%',
            }}
        >
            <Typography
                variant="h6"
                fontWeight={800}
                mb={3}
                sx={{
                    background: 'linear-gradient(135deg, #1E90FF 0%, #1c86ee 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}
            >
                🆕 Recent Joiners
            </Typography>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 700, fontSize: '0.75rem' }}>Employee</TableCell>
                            <TableCell sx={{ fontWeight: 700, fontSize: '0.75rem' }}>Department</TableCell>
                            <TableCell sx={{ fontWeight: 700, fontSize: '0.75rem' }} align="right">Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {recentEmployees.map((emp, index) => (
                            <Fade in timeout={500 + index * 100} key={index}>
                                <TableRow
                                    sx={{
                                        '&:hover': { bgcolor: '#f8f9fa' },
                                        transition: 'all 0.3s ease',
                                    }}
                                >
                                    <TableCell>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <Avatar
                                                sx={{
                                                    width: 32,
                                                    height: 32,
                                                    bgcolor: '#667eea',
                                                    fontSize: '0.875rem',
                                                }}
                                            >
                                                {emp.empName?.charAt(0) || 'E'}
                                            </Avatar>
                                            <Box>
                                                <Typography variant="body2" fontWeight={600}>
                                                    {emp.empName || 'Employee'}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    ID: {emp.empID}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="caption">
                                            {emp.deptName || 'N/A'}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                        <Chip
                                            label="Active"
                                            size="small"
                                            sx={{
                                                bgcolor: '#43e97b20',
                                                color: '#43e97b',
                                                fontWeight: 700,
                                                fontSize: '0.7rem',
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            </Fade>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

export default function ModernDashboard() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { user } = useSelector(state => state.auth)
    const { employeeList } = useSelector(state => state.emp)
    const { departments } = useSelector(state => state.dept)
    const { units } = useSelector(state => state.units)
    const { designations } = useSelector(state => state.desig)
    const { shifts } = useSelector(state => state.shifts)
    const { allowances } = useSelector(state => state.allowances)
    const { leaves } = useSelector(state => state.leaves)

    useEffect(() => {
        if (!user) {
            navigate('/Login')
        } else {
            dispatch(getCompanyData())
            dispatch(getEmployeeList())
            dispatch(getDepartments())
            dispatch(getUnits())
            dispatch(getDesignations())
            dispatch(getShifts())
            dispatch(getAllowances())
            dispatch(getLeaves())
        }
    }, [user, navigate, dispatch])

    // Calculate stats
    const activeEmployees = employeeList?.length || 0
    const totalDepartments = departments?.length || 0
    const totalUnits = units?.length || 0
    const totalDesignations = designations?.length || 0
    const totalShifts = shifts?.length || 0
    const totalAllowances = allowances?.length || 0
    const totalLeaves = leaves?.length || 0

    return (
        <>
            <ModernNavbar />
            <Box sx={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #7994aeff 0%, #97c8d8ff 100%)',
                py: 4,
                ml: 20, mr: 20, borderRadius: 10,
                mt: 10,
                border: '10px solid rgba(48, 48, 48, 0.3)',
            }}>
                <Container maxWidth="xl">
                    {/* Header Section */}
                    <Fade in timeout={800}>
                        <Box mb={4}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 4,
                                    background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
                                    backdropFilter: 'blur(20px)',
                                    borderRadius: 4,
                                    border: '1px solid rgba(255,255,255,0.3)',
                                }}
                            >
                                <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
                                    <Box>
                                        <Typography
                                            variant="h3"
                                            sx={{
                                                fontWeight: 900,
                                                background: 'linear-gradient(135deg, #429ffcff 0%, #1E90FF 100%)',
                                                backgroundClip: 'text',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                                mb: 1
                                            }}
                                        >
                                            Welcome Back! 👋
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary" fontWeight={500}>
                                            Here's what's happening with your HR System today
                                        </Typography>
                                    </Box>
                                    <Chip
                                        icon={<CalendarTodayIcon />}
                                        label={new Date().toLocaleDateString('en-US', {
                                            weekday: 'long',
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        })}
                                        sx={{
                                            px: 2,
                                            py: 3,
                                            fontSize: '0.9rem',
                                            fontWeight: 700,
                                            background: 'linear-gradient(135deg, #4ca6ffff 0%, #1E90FF 100%)',
                                            color: 'white',
                                        }}
                                    />
                                </Box>
                            </Paper>
                        </Box>
                    </Fade>

                    {/* Main Stats Grid2 */}
                    <Grid2 container spacing={3} mb={4}>
                        <Grid2 size={3}  >
                            <StatsCard
                                title="Total Employees"
                                value={activeEmployees}
                                icon={<PeopleIcon sx={{ fontSize: 28 }} />}
                                color="#d5d5d5ff"
                                gradient="linear-gradient(90deg, #ffffffff 0%, #b3b3b3ff 100%)"
                                route="/EmployeeList"
                                trend="up"
                                percentage={85}
                            />
                        </Grid2>
                        <Grid2 size={3}  >
                            <StatsCard
                                title="Departments"
                                value={totalDepartments}
                                icon={<BusinessIcon sx={{ fontSize: 28 }} />}
                                color="#d5d5d5ff"
                                gradient="linear-gradient(90deg, #ffffffff 0%, #b3b3b3ff 100%)"
                                route="/Departments"
                                trend="up"
                                percentage={92}
                            />
                        </Grid2>
                        <Grid2 size={3}  >
                            <StatsCard
                                title="Designations"
                                value={totalDesignations}
                                icon={<WorkIcon sx={{ fontSize: 28 }} />}
                                color="#d5d5d5ff"
                                gradient="linear-gradient(90deg, #ffffffff 0%, #b3b3b3ff 100%)"
                                route="/Designations"
                                trend="up"
                                percentage={78}
                            />
                        </Grid2>
                        <Grid2 size={3}  >
                            <StatsCard
                                title="Active Units"
                                value={totalUnits}
                                icon={<GroupsIcon sx={{ fontSize: 28 }} />}
                                color="#d5d5d5ff"
                                gradient="linear-gradient(90deg, #ffffffff 0%, #b3b3b3ff 100%)"
                                route="/Units"
                                trend="up"
                                percentage={88}
                            />
                        </Grid2>
                    </Grid2>

                    <Grid2 container spacing={3} mb={4}>
                        <Grid2 size={3}  >
                            <StatsCard
                                title="Work Shifts"
                                value={totalShifts}
                                icon={<AccessTimeIcon sx={{ fontSize: 28 }} />}
                                color="#d5d5d5ff"
                                gradient="linear-gradient(90deg, #ffffffff 0%, #b3b3b3ff 100%)"
                                route="/Shifts"
                                trend="up"
                                percentage={95}
                            />
                        </Grid2>
                        <Grid2 size={3}  >
                            <StatsCard
                                title="Allowances"
                                value={totalAllowances}
                                icon={<AccountBalanceWalletIcon sx={{ fontSize: 28 }} />}
                                color="#d5d5d5ff"
                                gradient="linear-gradient(90deg, #ffffffff 0%, #b3b3b3ff 100%)"
                                route="/Allowances"
                                trend="up"
                                percentage={72}
                            />
                        </Grid2>
                        <Grid2 size={3}  >
                            <StatsCard
                                title="Leave Types"
                                value={totalLeaves}
                                icon={<BeachAccessIcon sx={{ fontSize: 28 }} />}
                                color="#d5d5d5ff"
                                gradient="linear-gradient(90deg, #ffffffff 0%, #b3b3b3ff 100%)"
                                route="/LeavesManagement"
                                trend="up"
                                percentage={68}
                            />
                        </Grid2>
                        <Grid2 size={3}  >
                            <StatsCard
                                title="Salary Sheet"
                                value="Ready"
                                icon={<AttachMoneyIcon sx={{ fontSize: 28 }} />}
                                color="#d5d5d5ff"
                                gradient="linear-gradient(90deg, #ffffffff 0%, #b3b3b3ff 100%)"
                                route="/SalarySheet"
                                trend="up"
                                percentage={100}
                            />
                        </Grid2>
                    </Grid2>

                    {/* Analytics Section */}
                    <Grid2 container spacing={3} mb={10}>
                        <Grid2 size={6} >
                            <AttendanceOverviewCard employees={employeeList || []} />
                        </Grid2>
                        <Grid2 size={6} >
                            <DepartmentChartCard
                                departments={departments || []}
                                employees={employeeList || []}
                            />
                        </Grid2>
                        <Grid2 size={12} mt={8}>
                            <RecentEmployeesCard employees={employeeList || []} />
                        </Grid2>
                    </Grid2>

                    {/* <Grid2 container spacing={3} mb={10}>
                        <Grid2 size={6} >
                            <TopPerformersCard employees={employeeList || []} />
                        </Grid2>
                        <Grid2 size={6} >
                            <RecentEmployeesCard employees={employeeList || []} />
                        </Grid2>
                    </Grid2> */}

                    {/* Quick Actions Section */}
                    <Fade in timeout={1200}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 4,
                                background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
                                backdropFilter: 'blur(20px)',
                                borderRadius: 4,
                                border: '1px solid rgba(255,255,255,0.3)',
                            }}
                        >
                            <Typography
                                variant="h5"
                                fontWeight={800}
                                mb={3}
                                sx={{
                                    background: 'linear-gradient(135deg, #1E90FF 0%, #1c86ee 100%)',
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                }}
                            >
                                ⚡ Quick Actions
                            </Typography>
                            <Grid2 container spacing={2}>
                                <Grid2 size={6} >
                                    <QuickActionCard
                                        title="Register New Employee"
                                        description="Add a new team member to the system"
                                        icon={<PeopleIcon />}
                                        color="#1E90FF"
                                        route="/EmployeeRegistration"
                                    />
                                </Grid2>
                                <Grid2 size={6} >
                                    <QuickActionCard
                                        title="Mark Attendance"
                                        description="Record today's attendance for employees"
                                        icon={<AssignmentIcon />}
                                        color="#4facfe"
                                        route="/CurrDayAtt"
                                    />
                                </Grid2>
                                <Grid2 size={6} >
                                    <QuickActionCard
                                        title="Generate Salary Sheet"
                                        description="Create monthly salary report"
                                        icon={<AttachMoneyIcon />}
                                        color="#187bcd"
                                        route="/SalarySheet"
                                    />
                                </Grid2>
                                <Grid2 size={6} >
                                    <QuickActionCard
                                        title="Manage Leaves"
                                        description="Configure leave types and policies"
                                        icon={<LocalHospitalIcon />}
                                        color="#00bfff"
                                        route="/LeavesManagement"
                                    />
                                </Grid2>
                            </Grid2>
                        </Paper>
                    </Fade>
                </Container>
            </Box>
            <Footer />
        </>
    )
}
